module.exports = __webpack_public_path__ + "img/logo_consulta.0cb0f49d.png";